import { AccordionStep, DisplayType } from '@hb/domain';
import { environment } from '@hb/hypotheken-berekening.environment';
import { AccordionStateService } from '@hb/services/accordion-state/accordion-state.service';

import { inject, Injectable } from '@angular/core';

import { ApError } from '@ap/error';

@Injectable({
    providedIn: 'root'
})
export class MortgageCalculationService {
    private readonly accordionStateService = inject(AccordionStateService);

    showMobileDisplay(): boolean {
        return this.getDisplayType() === DisplayType.MOBILE;
    }

    showDisclaimer(): boolean {
        return this.getDisplayType() !== DisplayType.STICKY_MOBILE;
    }

    showAppointmentButton(apError?: ApError): boolean {
        return (
            this.getDisplayType() === DisplayType.DESKTOP ||
            this.getDisplayType() === DisplayType.ACCORDION ||
            (this.getDisplayType() === DisplayType.STICKY_MOBILE && apError !== undefined)
        );
    }

    showDefaultDisplay(): boolean {
        return this.getDisplayType() === DisplayType.MOBILE || this.getDisplayType() === DisplayType.ACCORDION;
    }

    showDesktopDisplay(): boolean {
        return this.getDisplayType() === DisplayType.DESKTOP;
    }

    showAccordion(): boolean {
        return this.getDisplayType() === DisplayType.ACCORDION;
    }

    showStickyMobileDisplay(): boolean {
        return this.getDisplayType() === DisplayType.STICKY_MOBILE;
    }

    showDesktopOrMobileDisplay(): boolean {
        return this.getDisplayType() === DisplayType.DESKTOP || this.getDisplayType() === DisplayType.MOBILE;
    }

    showMobileError(): boolean {
        return this.getDisplayType() === DisplayType.MOBILE || this.getDisplayType() === DisplayType.STICKY_MOBILE;
    }

    getDisplayType(): DisplayType {
        if (environment.mobile) {
            if (this.accordionStateService.getStepIsOpen(AccordionStep.MORTGAGE)) {
                return DisplayType.ACCORDION;
            }
            if (!this.accordionStateService.getDisplayFirstStepOnly()) {
                return DisplayType.STICKY_MOBILE;
            }
            return DisplayType.MOBILE;
        }

        if (!environment.mobile && this.accordionStateService.getStepIsOpen(AccordionStep.MORTGAGE)) {
            return DisplayType.ACCORDION;
        }
        return DisplayType.DESKTOP;
    }
}
